import {createApi} from '@reduxjs/toolkit/query/react'
import baseQueryWithAuth from "./baseQuery";

export interface AddStampRequest {
  storeId: string
  otp: string
}

export interface StampResponse {
  id: string
  stampDate: string
  rewardId: string
}

export interface MyStampsRequest {
  storeId: string
  limit: number
}

export const stampApi = createApi({
  reducerPath: 'stampApi',
  baseQuery: baseQueryWithAuth,
  tagTypes: ['Stamps'],
  endpoints: (builder) => ({
    addStamp: builder.mutation<void, AddStampRequest>({
      query: (payload) => ({
        url: `https://add-stamp.gyore-soma.workers.dev/${payload.storeId}?otp=${payload.otp}`,
        method: 'GET',
      }),
      invalidatesTags: ['Stamps'],
    }),
    getMyStamps: builder.query<StampResponse[], MyStampsRequest>({
      query: (payload: MyStampsRequest) => ({
        url: `https://get-my-stamps.gyore-soma.workers.dev/${payload.storeId}?limit=${payload.limit}`,
      }),
      providesTags: ['Stamps'],
    }),
  }),
})

export const { useAddStampMutation, useGetMyStampsQuery } = stampApi
